/* cart-upsell.js — <cart-upsell-hero>: the post-add yes/no line in the cart drawer.
   Loaded from cart-drawer.liquid on every page (empty cart included) — see the note there.
   The hero renders VISIBLE; this only hides it when the shopper has declined this session.
   "No thanks" is remembered for the browser session (sessionStorage); the drawer re-renders on
   every cart change, so each fresh <cart-upsell-hero> checks the flag when it connects. When the
   hero has been declined, the plain row for that item in the strip ([data-declined-only="<key>"]) is shown instead.
   v3 (Oct 9 2026): two cards share this element — data-key "cover" (spotter eyepieces) and "cloth" (bino
   eyepieces; the Lens Cloth). Each decline is its own flag; at most one card renders per cart (cart-upsell.liquid). */
(function () {
  var KEY = 'epoch-cart-upsell-declined';
  function declined() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function markDeclined(key) {
    try { var d = declined(); d[key] = true; sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (e) { /* private mode */ }
  }
  function syncFallbackRows(root) {
    var d = declined();
    (root || document).querySelectorAll('[data-declined-only]').forEach(function (row) {
      row.hidden = !d[row.getAttribute('data-declined-only') || 'cover'];
    });
  }
  if (!customElements.get('cart-upsell-hero')) {
    customElements.define('cart-upsell-hero', class extends HTMLElement {
      connectedCallback() {
        var key = this.dataset.key || 'cover';
        if (declined()[key]) { this.hidden = true; syncFallbackRows(); return; }
        this.hidden = false;
        var decline = this.querySelector('[data-decline]');
        if (decline) decline.addEventListener('click', function () {
          markDeclined(key);
          this.hidden = true;
          syncFallbackRows();
        }.bind(this));
      }
    });
  }
  syncFallbackRows();
  document.addEventListener('DOMContentLoaded', function () { syncFallbackRows(); });
})();
